var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareViewFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642578,
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_1011_19629)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7617 9.21387H13.2686C11.3847 9.21387 9.85742 10.7411 9.85742 12.6251V31.1181C9.85742 33.0022 11.3846 34.5293 13.2686 34.5293H22.3892L22.405 25.4832H20.0545C19.7491 25.4832 19.5012 25.2362 19.5001 24.9307L19.4886 22.0146C19.4874 21.7077 19.7363 21.4579 20.0432 21.4579H22.3895V18.6404C22.3895 15.3706 24.3865 13.5902 27.3032 13.5902H29.6969C30.0029 13.5902 30.2514 13.8385 30.2514 14.1448V16.6035C30.2514 16.9098 30.0032 17.158 29.6972 17.158L28.2282 17.1589C26.642 17.1589 26.3346 17.9126 26.3346 19.019V21.4583H29.8202C30.1526 21.4583 30.4102 21.7484 30.3709 22.0779L30.0253 24.9941C29.9924 25.2733 29.7556 25.4834 29.4746 25.4834H26.3504L26.3346 34.5298H31.7616C33.6455 34.5298 35.1728 33.0024 35.1728 31.1185V12.6251C35.1729 10.7412 33.6455 9.21387 31.7617 9.21387Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3893 34.5295L22.4053 25.4834H22.3662V34.5295H22.3893Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_19629",
    x1: 22.1426,
    y1: 0,
    x2: 22.1426,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B73E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2840B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareViewFb);
export default __webpack_public_path__ + "static/media/share-view-fb.e999e42090cedf9939afe479ff051232.svg";
export { ForwardRef as ReactComponent };